module.exports = __webpack_public_path__ + "img/41_25.1a633cc0.png";